<template>
  <div
    class="absolute flex flex-col justify-between space-y-6 rounded-sm bg-white p-5 whitespace-nowrap shadow-sm"
  >
    <lf-dropdown
      class="h-10 w-full"
      name="scoreModel"
      data-cy="score-model-dropdown"
      :options="models"
      :value="scoreModel"
      :placeholder="$t('SCORECARDS.SCORE_MODEL')"
      full-width
      hide-placeholder-when-value
      @change="scoreModel = $event"
    />
    <primary-button
      :disabled="!scoreModel"
      data-cy="apply-score-model"
      @click="applyScoreModel"
    >
      {{ $t("COMMON.APPLY") }}
    </primary-button>
  </div>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import { BPR_CONSUMER_SCORE_MODELS } from "@/helpers/constants/equifax";

import type { BOP_CONSUMER_SCORE_MODELS } from "@/helpers/constants/experian";

const { attributeId } = defineProps<{
  attributeId?: string;
}>();

const emit = defineEmits<{
  (event: "apply", value: keyof typeof BOP_CONSUMER_SCORE_MODELS): void;
}>();

const scoreModel = ref<keyof typeof BOP_CONSUMER_SCORE_MODELS | "">("");
const { getters } = useStore();

const bopConsumerScoreModels = computed<typeof BOP_CONSUMER_SCORE_MODELS>(
  () => getters["options/experianBopConsumerScoreModels"]
);

const models = computed(() =>
  attributeId?.startsWith("equifax")
    ? BPR_CONSUMER_SCORE_MODELS
    : bopConsumerScoreModels.value
);

const applyScoreModel = () => {
  if (scoreModel.value) {
    emit("apply", scoreModel.value);
  }
};
</script>
